import 'slick-carousel/slick/slick';

function cookies() {
    var cookieInfo = $('#cookies-info'),
        cookieClose = $('#cookies-info').find('.cookies-info__accept');
    checkCookie();

    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + expires + "; path=/";

    };

    function getCookie(cname) {

        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1);
            if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
        }
        return '';
    };

    function checkCookie() {
        var isExist = getCookie(document.domain + '-cookies-info');
        if (isExist != '') {
            cookieInfo.hide();
        } else {
            cookieInfo.show();
            cookieClose.on('click', function (e) {
                e.preventDefault();
                cookieInfo.hide();
                isExist = true;
                if (isExist != "" && isExist != null) {
                    setCookie(document.domain + '-cookies-info', isExist, 365);
                }
            });
        }
    };

};

function shuffleArray(array) {
    var i = array.length,
        j = 0,
        temp;

    while (i--) {

        j = Math.floor(Math.random() * (i + 1));

        // swap randomly chosen element with current element
        temp = array[i];
        array[i] = array[j];
        array[j] = temp;

    }

    return array;
}

function iframeResponsive() {
    // on resize
    const iframe = document.querySelector('iframe.game__create');

    if (iframe) {
        iframe.onResize = () => {
            this.container = this.frameElement.contentWindow.document.body;

            this.watch = () => {
                cancelAnimationFrame(this.watcher);

                if (this.lastScrollHeight !== container.scrollHeight) {
                    parent.resizeIframeToContentSize(this.frameElement);
                }
                this.lastScrollHeight = container.scrollHeight;
                this.watcher = requestAnimationFrame(this.watch);
            };

            this.watcher = window.requestAnimationFrame(this.watch);
        };
    }
}

function generateRandom(min = 0, max = 500000) {

    // find diff
    let difference = max - min;

    // generate random number
    let rand = Math.random();

    // multiply with difference
    rand = Math.floor(rand * difference);

    // add with min value
    rand = rand + min;

    return rand;
}

export default {cookies, generateRandom, shuffleArray, iframeResponsive};



// WEBPACK FOOTER //
// ./src/scripts/functions.js